<template>
  <div class="rescue-agreement-wrap">
<!-- 
<div>

<h1 align=center style='margin-top:7.05pt;margin-right:0cm;margin-bottom:7.05pt;
margin-left:0cm;text-align:center;background:white'><span style='font-family:
"PingFangSC",sans-serif;color:#333333;letter-spacing:1.0pt;background:
white'>道路救援服务协议</span></h1>

<h5 style='text-align:justify;text-justify:inter-ideograph'><span
style='font-size:14.0pt;color:#333333;letter-spacing:1.0pt;background:white'>重要提示：</span></h5>

<p class=MsoNormal><span>在使用大虾车服道路救援服务之前，请您仔细阅读本规则，并充分理解各条款内容。当您接受或使用道路救援服务时，即表示您作为本服务用户已知悉并同意本规则的全部内容。</span></p>

<h5 style='text-align:justify;text-justify:inter-ideograph'><span
style='font-size:14.0pt;color:#333333;letter-spacing:1.0pt;background:white'>一、
服务对象</span></h5>

<p class=MsoNormal style='text-indent:21.0pt'><span>9</span><span>座及以下非营运客车、轿车及整备质量<span>2</span>吨以下空载货车，车主通过平台支付完成费用后方可使用该服务。</span></p>

<h5 style='text-align:justify;text-justify:inter-ideograph'><span
style='font-size:14.0pt;color:#333333;letter-spacing:1.0pt;background:white'>二、
服务范围</span></h5>

<p class=MsoNormal><span>全国城市施救车辆所能通行和到达的区域（不含香港、澳门、台湾），并且当地已开通道路救援服务，<span>&nbsp;</span><strong>但不包括交通部门或其他部门规定限制第三方道路救援活动的路段，以及在高速公路、隧道、大桥、高架道路等收费或监管路段（以交管部门具体规定为准），</strong><span>&nbsp;</span>道路救援服务在路修结束时或在将车辆拖至用户指定维修厂处时终止。</span></p>

<h5 style='text-align:justify;text-justify:inter-ideograph'><span
style='font-size:14.0pt;color:#333333;letter-spacing:1.0pt;background:white'>三、
服务项目</span></h5>

<p class=MsoNormal><span>1</span><span>、 搭电：车辆因蓄电池亏电等情况造成车辆无法启动，提供蓄电池搭电服务；若已出现多次馈电、
蓄电池老化或车辆存在蓄电池以外的问题建议使用拖车服务，以避免搭电失败。</span></p>

<p class=MsoNormal><span>说明<span>:</span>因线路进水会造成短路引起电器设备损失或造成车辆损坏，故雨天或车辆进水的情况下，禁止提供搭电服务。</span></p>

<p class=MsoNormal><span>2</span><span>、 换胎：车辆因轮胎损坏无法行驶，到达现场更换备胎；用户须自备足气备胎，如车辆安装防盗螺丝，用户应自行提供防盗螺丝钥匙，若出现两条或以上轮胎损坏，或无足气可用备胎时，应使用拖车服务。</span></p>

<p class=MsoNormal><span>3</span><span>、 拖车：车辆出现故障无法行驶，或发生交通事故经现场处理完毕情况下，通过专业清障车将车辆拖至用户指定维修厂<span>&nbsp;</span><strong>（暂不包含车辆脱离正常行驶道路陷入困境，无法正常牵引上拖车的情形，包括：陷入路井、路沟，落入河流、水沟，侧翻、倒翻或其他不可预见的特殊情况），</strong>用户选择拖车起终地后平台显示的价格为一口价，<span>&nbsp;</span><strong>暂不支持目的地变更</strong><span>&nbsp;</span>（注：选择拖车目的地时平台显示的周边维修厂为直线示意距离，而非拖车行驶距离，不作为价格计算依据）。
拖车服务若发生以下场景产生额外救援服务费用，需要在线下与救援人员结算：</span></p>

<p class=MsoNormal><span>a) </span><span>地下车库：拖车服务中遇到地下车库限高无法实施救援时，额外安排小车前往地下车库将被救车辆拖离车库；</span></p>

<p class=MsoNormal><span>b) </span><span>辅助轮：在救援过程中为了不损伤车辆本身的技术性能，保障车辆完好需要增加辅助的措施来完成救援；</span></p>

<p class=MsoNormal><span>c) </span><span>等待费：救援人员到达现场无法立即展开救援，应用户要求等待<span>30</span>分钟以上的；</span></p>

<p class=MsoNormal><span>d) </span><span>路桥费：拖车服务过程中产生的高速公路费、过桥费、通行费、停车费等（停车费仅限救援人员在救援地或按用户要求停车产生的费用）。</span></p>

<h5 style='text-align:justify;text-justify:inter-ideograph'><span
style='font-size:14.0pt;color:#333333;letter-spacing:1.0pt;background:white'>四、
取消退款规则</span></h5>

<p class=MsoNormal><span>1</span><span>、 订单支付成功<span>10</span>分钟内，用户可取消订单并原路退回<span>100%</span>已支付金额。</span></p>

<p class=MsoNormal><span>2</span><span>、 订单支付超过<span>10</span>分钟且救援人员未到达现场，取消操作需要经过人工审核，若救援人员已派遣，将收取已支付金额的<span>50%</span>作为空驶费，且已使用的优惠券无法退回。</span></p>

<p class=MsoNormal><span>3</span><span>、 如果救援人员到达现场，订单不支持取消退款。</span></p>

<h5 style='text-align:justify;text-justify:inter-ideograph'><span
style='font-size:14.0pt;color:#333333;letter-spacing:1.0pt;background:white'>五、
服务说明</span></h5>

<p class=MsoNormal><span>进行道路救援服务前，您同意并进行以下授权：同意大虾车服将您的故障位置、车牌号、车型、姓名、手机号码等为提供该救援服务所必要的个人信息提供给相关救援人员，以便和您取得联系；为保证服务质量，允许救援人员在现场通过拍照、摄像、录音、记录等方式收集和处理道路救援服务有关的个人信息。</span></p>

<p class=MsoNormal><span>因上述救援服务有</span><span>一</span><span>定的保障性质，故对车辆状况和车主行为有</span><span>一</span><span>定的除外责任限制，下述情况下我们将无法提供上述服务，或需要视实际情况与您沟通，帮助解决。</span></p>

<p class=MsoNormal><span>(1) </span><span>战争、军事冲突、恐怖活动、暴乱、司法行为、行政行为。</span></p>

<p class=MsoNormal><span>(2)</span><span>驾驶员无有效的驾驶资格或者饮酒、吸毒、被药物麻醉的。</span></p>

<p class=MsoNormal><span>(3)</span><span>利用车辆从事犯罪的。</span></p>

<p class=MsoNormal><span>(4)</span><span>申请人车辆没有配备拖车钩的。</span></p>

<p class=MsoNormal><span>(5)</span><span>我们不对任何未由我们处理或未由我们网络提供服务所发生的费用负责。</span></p>

<p class=MsoNormal><span>2.</span><span>被救援车辆必须是您登记的相对应的车辆<span>;</span>车辆发生故障后，应采取合理的自救、保护措施，并积极协助救援。</span></p>

<p class=MsoNormal><span>3.</span><span>被救援车辆属于<span>9</span>座<span>(</span>含<span>) </span>以下客车、轿车及整备质量<span>2</span>吨以下空载货车范围以外的车辆，救援服务费用将根据现场情况个案协商。</span></p>

<p class=MsoNormal><span>4.</span><span>被救援车辆在非常规铺装道路上行驶<span>(</span>非常规铺装道路系指<span>:</span>除公路、城市道路和单位管辖范围但允许社会机动车通行的地方以外的其他地方。包括但不限于矿区、厂区、林区、农场单位自建的不通行社会车辆的道路、乡间小道、田野机耕道、河床、沙滩、山地等不适合</span><span>车</span><span>辆行驶的道路<span>)</span>，救援服务费用将根据现场情况个案协商。</span></p>

<p class=MsoNormal><span>5.</span><span>如发生下列情况，救援中心在合理可能的基础上尽力提供服务<span>:</span></span></p>

<p class=MsoNormal><span>(1)</span><span>高峰时期和交通拥挤的情况下。</span></p>

<p class=MsoNormal><span>(2)</span><span>正在修路和施工的道路和接近有困难的道路。</span></p>

<p class=MsoNormal><span>(3)</span><span>其他受限制的地区。</span></p>

<p class=MsoNormal><span>(4)</span><span>在其它无法预见的不可能提供服务的情况下。</span></p>

<p class=MsoNormal><span>6.</span><span>如在救援时发现申请人无备用</span><span>车</span><span>胎或配件，或者备用车胎或配件无法使用，需返回购买所需材料的交通费等由于申请人原因导致救援成本增加，增加部分费用需由申请人承担。</span></p>

<p class=MsoNormal><span>7.</span><span>在执行救援过程中，如产生了停车费、看管费、过路过桥费、高速费等额外费用，需由</span><span>申</span><span>请人承担。</span></p>

<p class=MsoNormal><span>六、免责条款</span></p>

<p class=MsoNormal><span>您确认申请救援的车辆状况和用户行为不符合以下任何一项除外责任，并同意大虾车服在下述情况下可免除责任：</span></p>

<p class=MsoNormal><span>1</span><span>、 车辆参与赛车、拉力赛、速度或耐久性测试、试乘试驾以及在非官方道路上驾驶。</span></p>

<p class=MsoNormal><span>2</span><span>、 车辆用于出租车或租赁等商业用途。</span></p>

<p class=MsoNormal><span>3</span><span>、 车辆运载碳氢燃料、易燃易爆或有毒矿物质或其它物料造成损失的。</span></p>

<p class=MsoNormal><span>4</span><span>、 车辆作为救护车运载伤员或作为灵车运载死者的。</span></p>

<p class=MsoNormal><span>5</span><span>、 车辆所承载的行李未做良好包装或承载了易碎易腐物品的。</span></p>

<p class=MsoNormal><span>6</span><span>、 车辆不具备应有的文件或证明（包括技术检验及强制性保险）或不符合法定的车辆运行公共道路交通的要求的。</span></p>

<p class=MsoNormal><span>7</span><span>、 因故意损坏、破坏或参与违法犯罪行为引起的故障。</span></p>

<p class=MsoNormal><span>8</span><span>、 车辆的抛锚是直接或间接因警方或其他有关部门介入引起的。</span></p>

<p class=MsoNormal><span>9</span><span>、 车辆的操作违反该车使用说明、非法改装等引起的损坏或未根据车辆制造商的建议定期保养。</span></p>

<p class=MsoNormal><span>10</span><span>、 因用户或用户委托的驾驶人员违规，而导致超员、运载物品或动物的重量、乘载或安排方式上违规。</span></p>

<p class=MsoNormal><span>11</span><span>、 车辆故障或事故发生后引发的任何相关费用或财产损失。</span></p>

<p class=MsoNormal><span>11</span><span>、 车辆故障或事故发生后引发的任何相关费用或财产损失。</span></p>

<p class=MsoNormal><span>12</span><span>、 车辆的驾驶人员处于下列任一情况者：</span></p>

<p class=MsoNormal><span>a) </span><span>处于醉酒状态中，车辆驾驶人员的血液中的酒精含量超过交通法、机动车行驶法、道路安全法或者《中华人民共和国道路交通安全法》、《中华人民共和国道路交通安全法实施条例》的相关规定的，则视为醉酒；</span></p>

<p class=MsoNormal><span>b) </span><span>车辆驾驶人员处于毒品、毒物、非处方的麻醉剂的影响下；</span></p>

<p class=MsoNormal><span>c) </span><span>不具有用户车辆类别应有的驾驶证或相应证件，或驾驶证等证件因违规而被吊销或吊扣的。</span></p>

<p class=MsoNormal><span>13</span><span>、 现场被救车辆车牌与申请不一致的。</span></p>

<p class=MsoNormal><span>14</span><span>、 经救援人员现场认定车辆情况与用户报案描述严重不符，且此种误描述根据救援人员的判定，并非是用户对车辆认知欠缺而导致的。</span></p>

<p class=MsoNormal><span>15</span><span>、 用户不配合检查或蓄意破坏仪表等设施导致救援人员无法检查车辆，不配合验证身份或转让他人使用服务。</span></p>

<p class=MsoNormal><span>16</span><span>、 用户已被大虾车服拉入滥用服务黑名单。</span></p>

<p class=MsoNormal><span>17</span><span>、 当车辆在服务过程中发生交通事故时，大虾车服对交通法规规定的用户车辆保险赔付范围内的项目不承担责任。</span></p>

<p class=MsoNormal><span>18</span><span>、 在实施救援过程中，因车辆自身问题（如：拖车钩、拖车钩座或车前盖断裂、脱落等）或其他非救援人员过错导致的用户车辆损失，或导致其他任何人身伤亡或财产损失，大虾车服无须承担任何责任。</span></p>

</div> -->


<h1 align=center style='margin-top:7.05pt;margin-right:0cm;margin-bottom:7.05pt;
margin-left:0cm;text-align:center;background:white'><span style='font-family:
"PingFangSC",sans-serif;color:#333333;letter-spacing:1.0pt;background:
white'>道路救援服务协议</span></h1>

<h5 style='text-align:justify;text-justify:inter-ideograph'><span
style='font-size:14.0pt;color:#333333;letter-spacing:1.0pt;background:white'>重要提示：</span></h5>

<p class=MsoNormal><span style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>在使用大虾车服道路救援服务之前，请您仔细阅读本规则，并充分理解各条款内容。当您接受或使用道路救援服务时，即表示您作为本服务用户已知悉并同意本规则的全部内容。</span></p>

<h5 style='text-align:justify;text-justify:inter-ideograph'><span
style='font-size:14.0pt;color:#333333;letter-spacing:1.0pt;background:white'>一、
服务对象</span></h5>

<p class=MsoNormal style='text-indent:21.0pt'><span lang=EN-US
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>9</span><span style='font-size:14.0pt;
font-family:"PingFangSC",sans-serif;color:#333333;letter-spacing:1.0pt;
background:white'>座及以下非营运客车、轿车及整备质量<span lang=EN-US>2</span>吨以下空载货车，车主通过平台支付完成费用后方可使用该服务。</span></p>

<p class=MsoNormal><span style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>。</span></p>

<h5 style='text-align:justify;text-justify:inter-ideograph'><span
style='font-size:14.0pt;color:#333333;letter-spacing:1.0pt;background:white'>二、
服务范围</span></h5>

<p class=MsoNormal><span style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>全国城市施救车辆所能通行和到达的区域（不含香港、澳门、台湾），并且当地已开通道路救援服务，<span
lang=EN-US>&nbsp;</span><strong>但不包括交通部门或其他部门规定限制第三方道路救援活动的路段，以及在高速公路、隧道、大桥、高架道路等收费或监管路段（以交管部门具体规定为准），</strong><span
lang=EN-US>&nbsp;</span>道路救援服务在路修结束时或在将车辆拖至用户指定维修厂处时终止。</span></p>

<h5 style='text-align:justify;text-justify:inter-ideograph'><span
style='font-size:14.0pt;color:#333333;letter-spacing:1.0pt;background:white'>三、
服务项目</span></h5>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>1</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 搭电：车辆因蓄电池亏电等情况造成车辆无法启动，提供蓄电池搭电服务；若已出现多次馈电、
蓄电池老化或车辆存在蓄电池以外的问题建议使用拖车服务，以避免搭电失败。</span></p>

<p class=MsoNormal><span style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>说明<span lang=EN-US>:</span>因线路进水会造成短路引起电器设备损失或造成车辆损坏，故雨天或车辆进水的情况下，禁止提供搭电服务。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>2</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 换胎：车辆因轮胎损坏无法行驶，到达现场更换备胎；用户须自备足气备胎，如车辆安装防盗螺丝，用户应自行提供防盗螺丝钥匙，若出现两条或以上轮胎损坏，或无足气可用备胎时，应使用拖车服务。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>3</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 拖车：车辆出现故障无法行驶，或发生交通事故经现场处理完毕情况下，通过专业清障车将车辆拖至用户指定维修厂<span
lang=EN-US>&nbsp;</span><strong>（暂不包含车辆脱离正常行驶道路陷入困境，无法正常牵引上拖车的情形，包括：陷入路井、路沟，落入河流、水沟，侧翻、倒翻或其他不可预见的特殊情况），</strong>用户选择拖车起终地后平台显示的价格为一口价，<span
lang=EN-US>&nbsp;</span><strong>暂不支持目的地变更</strong><span lang=EN-US>&nbsp;</span>（注：选择拖车目的地时平台显示的周边维修厂为直线示意距离，而非拖车行驶距离，不作为价格计算依据）。
拖车服务若发生以下场景产生额外救援服务费用，需要在线下与救援人员结算：</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>a) </span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>地下车库：拖车服务中遇到地下车库限高无法实施救援时，额外安排小车前往地下车库将被救车辆拖离车库；</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>b) </span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>辅助轮：在救援过程中为了不损伤车辆本身的技术性能，保障车辆完好需要增加辅助的措施来完成救援；</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>c) </span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>等待费：救援人员到达现场无法立即展开救援，应用户要求等待<span
lang=EN-US>30</span>分钟以上的；</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>d) </span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>路桥费：拖车服务过程中产生的高速公路费、过桥费、通行费、停车费等（停车费仅限救援人员在救援地或按用户要求停车产生的费用）。</span></p>

<h5 style='text-align:justify;text-justify:inter-ideograph'><span
style='font-size:14.0pt;color:#333333;letter-spacing:1.0pt;background:white'>四、
取消退款规则</span></h5>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>1</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 订单支付成功<span lang=EN-US>10</span>分钟内，用户可取消订单并原路退回<span
lang=EN-US>100%</span>已支付金额。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>2</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 订单支付超过<span lang=EN-US>10</span>分钟且救援人员未到达现场，取消操作需要经过人工审核，若救援人员已派遣，将收取已支付金额的<span
lang=EN-US>50%</span>作为空驶费，且已使用的优惠券无法退回。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>3</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 如果救援人员到达现场，订单不支持取消退款。</span></p>

<h5 style='text-align:justify;text-justify:inter-ideograph'><span
style='font-size:14.0pt;color:#333333;letter-spacing:1.0pt;background:white'>五、
服务说明</span></h5>

<p class=MsoNormal><span style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>进行道路救援服务前，您同意并进行以下授权：同意大虾车服将您的故障位置、车牌号、车型、姓名、手机号码等为提供该救援服务所必要的个人信息提供给相关救援人员，以便和您取得联系；为保证服务质量，允许救援人员在现场通过拍照、摄像、录音、记录等方式收集和处理道路救援服务有关的个人信息。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>因上述救援服务有</span><span
lang=ZH style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>一</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>定的保障性质，故对车辆状况和车主行为有</span><span lang=ZH
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>一</span><span style='font-size:14.0pt;
font-family:"PingFangSC",sans-serif;color:#333333;letter-spacing:1.0pt;
background:white'>定的除外责任限制，下述情况下我们将无法提供上述服务，或需要视实际情况与您沟通，帮助解决。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>(1) </span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>战争、军事冲突、恐怖活动、暴乱、司法行为、行政行为。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>(2)</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>驾驶员无有效的驾驶资格或者饮酒、吸毒、被药物麻醉的。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>(3)</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>利用车辆从事犯罪的。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>(4)</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>申请人车辆没有配备拖车钩的。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>(5)</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>我们不对任何未由我们处理或未由我们网络提供服务所发生的费用负责。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>2.</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>被救援车辆必须是您登记的相对应的车辆<span lang=EN-US>;</span>车辆发生故障后，应采取合理的自救、保护措施，并积极协助救援。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>3.</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>被救援车辆属于<span lang=EN-US>9</span>座<span
lang=EN-US>(</span>含<span lang=EN-US>) </span>以下客车、轿车及整备质量<span lang=EN-US>2</span>吨以下空载货车范围以外的车辆，救援服务费用将根据现场情况个案协商。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>4.</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>被救援车辆在非常规铺装道路上行驶<span lang=EN-US>(</span>非常规铺装道路系指<span
lang=EN-US>:</span>除公路、城市道路和单位管辖范围但允许社会机动车通行的地方以外的其他地方。包括但不限于矿区、厂区、林区、农场单位自建的不通行社会车辆的道路、乡间小道、田野机耕道、河床、沙滩、山地等不适合</span><span
lang=ZH style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>车</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>辆行驶的道路<span lang=EN-US>)</span>，救援服务费用将根据现场情况个案协商。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>5.</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>如发生下列情况，救援中心在合理可能的基础上尽力提供服务<span
lang=EN-US>:</span></span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>(1)</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>高峰时期和交通拥挤的情况下。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>(2)</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>正在修路和施工的道路和接近有困难的道路。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>(3)</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>其他受限制的地区。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>(4)</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>在其它无法预见的不可能提供服务的情况下。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>6.</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>如在救援时发现申请人无备用</span><span lang=ZH
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>车</span><span style='font-size:14.0pt;
font-family:"PingFangSC",sans-serif;color:#333333;letter-spacing:1.0pt;
background:white'>胎或配件，或者备用车胎或配件无法使用，需返回购买所需材料的交通费等由于申请人原因导致救援成本增加，增加部分费用需由申请人承担。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>7.</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>在执行救援过程中，如产生了停车费、看管费、过路过桥费、高速费等额外费用，需由</span><span
lang=ZH style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>申</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>请人承担。</span></p>

<p class=MsoNormal><span lang=ZH style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>六、免责条款</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>您确认申请救援的车辆状况和用户行为不符合以下任何一项除外责任，并同意大虾车服在下述情况下可免除责任：</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>1</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 车辆参与赛车、拉力赛、速度或耐久性测试、试乘试驾以及在非官方道路上驾驶。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>2</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 车辆用于出租车或租赁等商业用途。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>3</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 车辆运载碳氢燃料、易燃易爆或有毒矿物质或其它物料造成损失的。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>4</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 车辆作为救护车运载伤员或作为灵车运载死者的。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>5</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 车辆所承载的行李未做良好包装或承载了易碎易腐物品的。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>6</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 车辆不具备应有的文件或证明（包括技术检验及强制性保险）或不符合法定的车辆运行公共道路交通的要求的。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>7</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 因故意损坏、破坏或参与违法犯罪行为引起的故障。</span></p>

<p class=MsoNormal><span lang=EN-US
style='font-size:10.0pt;font-family:Symbol;color:#333333;letter-spacing:1.0pt'>·<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>8</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 车辆的抛锚是直接或间接因警方或其他有关部门介入引起的。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>9</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 车辆的操作违反该车使用说明、非法改装等引起的损坏或未根据车辆制造商的建议定期保养。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>10</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 因用户或用户委托的驾驶人员违规，而导致超员、运载物品或动物的重量、乘载或安排方式上违规。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>11</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 车辆故障或事故发生后引发的任何相关费用或财产损失。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>11</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 车辆故障或事故发生后引发的任何相关费用或财产损失。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>12</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 车辆的驾驶人员处于下列任一情况者：</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>a) </span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>处于醉酒状态中，车辆驾驶人员的血液中的酒精含量超过交通法、机动车行驶法、道路安全法或者《中华人民共和国道路交通安全法》、《中华人民共和国道路交通安全法实施条例》的相关规定的，则视为醉酒；</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>b) </span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>车辆驾驶人员处于毒品、毒物、非处方的麻醉剂的影响下；</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>c) </span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>不具有用户车辆类别应有的驾驶证或相应证件，或驾驶证等证件因违规而被吊销或吊扣的。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>13</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 现场被救车辆车牌与申请不一致的。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>14</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 经救援人员现场认定车辆情况与用户报案描述严重不符，且此种误描述根据救援人员的判定，并非是用户对车辆认知欠缺而导致的。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>15</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 用户不配合检查或蓄意破坏仪表等设施导致救援人员无法检查车辆，不配合验证身份或转让他人使用服务。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>16</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 用户已被大虾车服拉入滥用服务黑名单。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>17</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 当车辆在服务过程中发生交通事故时，大虾车服对交通法规规定的用户车辆保险赔付范围内的项目不承担责任。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;
color:#333333;letter-spacing:1.0pt;background:white'>18</span><span
style='font-size:14.0pt;font-family:"PingFangSC",sans-serif;color:#333333;
letter-spacing:1.0pt;background:white'>、 在实施救援过程中，因车辆自身问题（如：拖车钩、拖车钩座或车前盖断裂、脱落等）或其他非救援人员过错导致的用户车辆损失，或导致其他任何人身伤亡或财产损失，大虾车服无须承担任何责任。</span></p>


  </div>
</template>

<script>
// 此页面为 word 文档导出页面
export default {
  data() {
    return {

    };
  },
  async mounted() {

  },
  methods: {
  }
};
</script>

<style lang="scss">
.rescue-agreement-wrap {
    line-height: 1.5;
    padding: 15px;
    background-color: #fff;
  //   h1 {
  //       font-size: 24px;
  //   }
  //   h5 {
	//     font-size:10px;
  //   }
  //   p.MsoNormal, li.MsoNormal, div.MsoNormal {
  //       text-align:justify;
  //       text-justify:inter-ideograph;
  //       font-size:10px;
  //   }
	// p.MsoNormal {
	// 	margin-left:0cm;
  //       text-indent:0cm;
  //       font-size:14.0pt;
  //       color:#333333;letter-spacing:1.0pt;
	// }
  strong {
    font-weight: bolder;
  }
 /* Font Definitions */
 @font-face
	{font-family:宋体;
	panose-1:2 1 6 0 3 1 1 1 1 1;}
@font-face
	{font-family:"Cambria Math";
	panose-1:2 4 5 3 5 4 6 3 2 4;}
@font-face
	{font-family:Calibri;
	panose-1:2 15 5 2 2 2 4 3 2 4;}
@font-face
	{font-family:PingFangSC;
	panose-1:2 11 4 0 0 0 0 0 0 0;}
@font-face
	{font-family:"\@PingFangSC";}
@font-face
	{font-family:"\@宋体";
	panose-1:2 1 6 0 3 1 1 1 1 1;}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{margin:0cm;
	text-align:justify;
	text-justify:inter-ideograph;
	font-size:10.5pt;
	font-family:"Calibri",sans-serif;}

	.MsoNormal {
		margin-left:0cm;text-indent:0cm;
	}
h1
	{margin-right:0cm;
	margin-left:0cm;
	font-size:24.0pt;
	font-family:宋体;}
h5
	{margin-right:0cm;
	margin-left:0cm;
	font-size:10.0pt;
	font-family:宋体;}
.MsoChpDefault
	{font-size:10.0pt;}
@page WordSection1
	{size:595.3pt 841.9pt;
	margin:72.0pt 90.0pt 72.0pt 90.0pt;
	;}
div.WordSection1
	{page:WordSection1;}
 /* List Definitions */
 ol
	{margin-bottom:0cm;}
ul
	{margin-bottom:0cm;}
}
</style>
